<!-- 问答组件 -->
<template>
  <div id="question-answer">
    <div class="placeholder"></div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  methods: { },
  created() {},
  mounted() {
    BJY.QuestionAnswer.create({
      element: $("#question-answer .placeholder"),
      replace: true,
      // 是否能够管理问题，老师或者助教传入true，学生传入false，会依据这个参数创建不同视图的面板
      canManageQuestion: BJY.auth.isTeacher(),
      // 每分钟限制发送的次数，可不传，默认值为10
      limitPerMinute: 100,
      // 每页显示的条数，可不传，默认为50
      countPerPage: 50,
      // 输入框可输入的最大长度，可不传，默认为140
      inputMaxLength: 400,
      // 是否是滑动翻页，仅在移动端时可用！！默认为false
      pageBySwipe: false,
      // 复制完成时的回调
      onCopyFinish: function () {},
    });
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
//@import url(); 引入公共css类
#question-answer {
  position: absolute;
  width: 100%;
  bottom: 0;
  top: 0;

  .bjy-question-answer {
    position: absolute !important;
    top: 0px !important;
    bottom: 0 !important;
    width: 100% !important;
  }

  .bjy-sender-box {
    bottom: 42px !important;
  }
  .bjy-footer {
    height: 36px !important;
  }
  .bjy-pager {
    align-items: center !important;
  }
  .bjy-question-list .bjy-scrollable {
    position: absolute !important;
    bottom: 30px !important;
    top: 42px !important;
    width: 100% !important;
    height: unset;
  }
}
</style>
